<template class="full-height">
  <div class="member-app-container" style="position: relative; height: 100%">
    <el-alert title="預設角色為TC-TRAVEL-LEADER" type="success" :closable="false"> </el-alert>
    <member-data :pageRoles="roles" :title="title" />
  </div>
</template>
<script>
export default {
  name: 'tcMemberManagement',
  components: {
    memberData: () => import('@/views/ita/toursCombine/member/components/memberList.vue'),
  },
  data() {
    return {
      roles: ['TC-TRAVEL-LEADER'],
      title: 'TCLeader',
    }
  },
}
</script>
<style>
.full-height {
  position: relative;
  height: 100%;
}
</style>
